const DRAFT_KEY = 'monezite_post_problem_draft';

export interface ProblemDraft {
  problem: string;
  category: string;
  town: string;
  country: string;
  continent: string;
  dateOccurred: string;
  dateFuture: string;
  affectedGroup: string;
  effects: string;
  workaround: string;
  proposedSolution: string;
  savedAt: number; // timestamp
}

/** Returns true if the draft has any meaningful content */
function hasMeaningfulContent(draft: ProblemDraft): boolean {
  return !!(
    draft.problem.trim() ||
    draft.category ||
    draft.town.trim() ||
    draft.country.trim() ||
    draft.effects.trim() ||
    draft.workaround.trim() ||
    draft.proposedSolution.trim()
  );
}

export function saveDraft(formData: Omit<ProblemDraft, 'savedAt'>): void {
  try {
    const draft: ProblemDraft = { ...formData, savedAt: Date.now() };
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // localStorage may be unavailable in some environments
  }
}

export function loadDraft(): ProblemDraft | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const draft: ProblemDraft = JSON.parse(raw);
    if (!hasMeaningfulContent(draft)) return null;
    return draft;
  } catch {
    return null;
  }
}

export function clearDraft(): void {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    // ignore
  }
}
